var Mn = require('backbone.marionette'),
    Bb = require('backbone'),
    $ = require('jquery'),
    scope = require('scope'),
    helpers = require('./helpers'),
    Uri = require('urijs');

var Router = Mn.Object.extend({
    initialize: function (app) {
        this.root = new Uri($('#base-id').attr('href'));
        this.real = new Bb.Router();
        this.app = app;
        this.init();
    },
    init: function () {
        var self = this;
        var route = this.real;
        Bb.history.start({
            pushState: true,
            hashChange: false,
            root: self.root.pathname()
        });
        route.route(/.*/, function () {
            self.page(location.href);
        });

        $(document).on('click', 'a:not(a[data-bypass])',function (event) {
            var link = event.currentTarget;
            // Only anchors tags
            if (link.tagName.toUpperCase() !== 'A')
                return;

            if (link.target === '_blank') {
                return;
            }

            // Middle click, cmd click, and ctrl click should open
            // links in a new tab as normal.
            if ( event.which > 1 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey )
                return;

            // Ignore cross origin links
            if ( location.protocol !== link.protocol || location.hostname !== link.hostname )
                return;

            // Ignore event with default prevented
            if (event.isDefaultPrevented())
                return;

            event.preventDefault();
            self.navigate(link.href);
        });
    },
    navigate: function (url, replace) {
        var full = this.root.toString(), fragment = (url + '/' === full) ? '' : url.replace(full,  ''),
            parts = fragment.split('#');
        var matchs = Bb.history.navigate(parts[0], {trigger: true, replace: replace});
        if (parts[1]) {
            window.history.replaceState({}, document.title, url);
            helpers.anchor(parts[1]);
        } else if (window.location.href.indexOf('#') > -1) {
            var uri = window.location.href.substr(0, window.location.href.indexOf('#'));
            window.history.replaceState({}, document.title, uri);
            helpers.anchor(0);
        } else if (typeof matchs  === 'undefined') {
            helpers.anchor(0);
        }
        scope.app.trigger('routed');
    },
    notrigger: function (url) {
        var full = this.root.toString(), navigate = (url + '/' === full) ? '' : url.replace(full,  '');
        Bb.history.navigate(navigate, {trigger: false, replace: false});
    },
    page: function (url) {
        $.ajax({
            pushstate: true,
            url: url,
            dataType: 'json'
        }).done(function() {
            var page = window.location.pathname + '?utm_source=website';
            ga('send', 'pageview', page);
        });
    }
});
module.exports = Router;



//////////////////
// WEBPACK FOOTER
// ./resources/assets/site/scripts/libs/router.js
// module id = 232
// module chunks = 3